import FactCard from './FactCard.jsx'
import FilterToggle from './FilterToggle.jsx'
import ListeningIndicator from './ListeningIndicator.jsx'

export default function FactStream({ list, filter, onFilterChange }) {
  // Two distinct empty states: the "all" filter empty means recording has
  // just started and nothing has been extracted yet → animate to convey
  // that we're working. The "essentials" filter empty means there ARE
  // facts but none are essential → a static hint is more appropriate.
  const empty = list.length === 0
  return (
    <div>
      <div className="mb-3.5 flex items-center justify-between">
        <div className="text-[11px] font-medium uppercase tracking-[1.5px] text-muted">Faits</div>
        <FilterToggle value={filter} onChange={onFilterChange} />
      </div>
      {empty && filter === 'all' && <ListeningIndicator />}
      {empty && filter !== 'all' && (
        <div className="rounded-lg border border-dashed border-line p-6 text-center text-[12.5px] text-muted">
          Aucun fait essentiel pour le moment.
        </div>
      )}
      {!empty && list.map((f, i) => <FactCard key={`${f.section}-${i}-${f.last_updated || i}`} fact={f} />)}
    </div>
  )
}
